<template>
  <div class="hello">
    <div class="hi" ref="chartdiv"></div>
  </div>
</template>

<script>
/* Imports */
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';

import dataSankey from '../data/agrupadas'

am4core.useTheme(am4themes_animated);

export default {
  name: 'Agrupadas',
  mounted() {
    let chart = am4core.create(this.$refs.chartdiv, am4charts.SankeyDiagram);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.data = dataSankey;

    let hoverState = chart.links.template.states.create('hover');
    hoverState.properties.fillOpacity = 0.6;

    chart.dataFields.fromName = 'desde';
    chart.dataFields.toName = 'hacia';
    chart.dataFields.value = 'valor';

    chart.links.template.tooltipText = "Origen: {desde} \n Destino: {hacia} \n Cantidad: {valor}";
    chart.links.template.propertyFields.id = 'id';
    // chart.links.template.colorMode = 'solid';
    // chart.links.template.fill = new am4core.InterfaceColorSet().getFor('alternativeBackground');
    // chart.links.template.fillOpacity = 0.1;
    // chart.links.template.tooltipText = '';

    // highlight all links with the same id beginning
    chart.links.template.events.on('over', (event) => {
      let link = event.target;
      let id = link.id.split('-')[0];

      chart.links.each((link) => {
        if (link.id.indexOf(id) != -1) {
          link.isHover = true;
        }
      });
    });

    chart.links.template.events.on('out', () => {
      chart.links.each((link) => {
        link.isHover = false;
      });
    });

    // for right-most label to fit
    chart.paddingRight = 30;
      
    // chart.legend = new am4charts.Legend();
    // chart.legend.useDefaultMarker = true;
    // let marker = chart.legend.markers.template.children.getIndex(0);
    // marker.cornerRadius(12, 12, 12, 12);

    chart.exporting.menu = new am4core.ExportMenu();

  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hi {
  width: 100%;
  height: 500px;
}
</style>
